import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useVendorMode } from "@/contexts/VendorModeContext";

/**
 * VendorRoute — protects vendor-only routes.
 * Non-vendor users are silently redirected to user mode home.
 */
export function VendorRoute({ children }) {
  const { token, loading: authLoading } = useAuth();
  const { isVerified, loading: modeLoading } = useVendorMode();

  if (authLoading || modeLoading) return null;
  if (!token) return <Navigate to="/onboarding" replace />;
  if (!isVerified) return <Navigate to="/" replace />;
  return children;
}

/**
 * PendingVendorBanner — persistent but dismissible banner for unverified vendors.
 */
export function PendingVendorBanner({ onDismiss }) {
  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-between" data-testid="vendor-pending-banner">
      <p className="text-xs text-amber-800">
        Your vendor verification is pending. We will notify you when approved.
      </p>
      <button onClick={onDismiss} className="text-amber-600 hover:text-amber-800 text-xs font-bold ml-2 shrink-0" data-testid="dismiss-vendor-banner">
        Dismiss
      </button>
    </div>
  );
}
